import {Affix, FloatButton} from 'antd';
import {useEffect, useState} from 'react';
import '../ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const img1 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/ws1.jpg';
const img2 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/ws2.jpg';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';
const App = () => {
    useEffect(() => {
        // 配置swiper播放 配置项都写这里面
        // console.log(1232112312)
        // const mySwiper = new Swiper('.swiper', {
        //     autoplay: true,
        //     loop: true
        // })
        window.scrollTo(0, 0);

    }, [])
    const [scrollPosition, setScrollPosition] = useState(0);
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }

    function createMarkup() {
        return {
            __html: `<div class="nyrcon">
                    <img src="`+img1+`" alt="无损探伤" class="pprr">
                    <div class="nyrt"><h1 class="contact-tit">无损探伤</h1></div>
                    <div class="cc-pp">
                        <h2><span style="font-size: 16px; color: rgb(0, 0, 0);"><strong>无损探伤介绍</strong></span></h2><p><span style="font-size: 16px; color: rgb(0, 0, 0);"></span></p><p><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">无损检测</span></a><span style="color: rgb(0, 0, 0);">(Non Destructive Testing)缩写是NDT(或NDE,non-destructive 
examination)也叫无损探伤，是在不损害或不影响被检测对象使用性能的前提下，采用NDT 包含了许多种已可有效应用的方法，最常用的 NDT 
方法有：超声，射线，涡流、磁粉、渗透等原理技术对材料,零件内进行部缺陷，结构，失效分析等。</span></p><p style="text-align: center;"><img src="`+img2+`" title="1666922442604984.jpg" alt="ws.jpg"></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);"><strong>无损探伤检测方法</strong></span></h2><p><span style="color: rgb(0, 0, 0);"><strong>1、磁粉探伤MT</strong></span></p><p><span style="color: rgb(0, 0, 0);">属于</span><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">无损探伤</span></a><span style="color: rgb(0, 0, 0);">五大常用方法之一，简称MT (Magnetic Particle 
Testing)对检测材料内部施加磁场使其磁化，然后在工件表面撒上磁粉观察磁粉分布变化进而达到对材料缺陷分析判断的方法。</span></p><p><span style="color: rgb(0, 0, 0);"><strong>2、超声探伤UT</strong></span></p><p><span style="color: rgb(0, 0, 0);">超声检测，是利用超声波技术进行检测工作的，是五种常规无损检测方法的一种。主要利用了超声波的强穿透性，较好的方向性，收集超声波在不同介质中的反射，干涉波转化为电子数字信号于屏幕上，实现无损探伤。</span></p><p><span style="color: rgb(0, 0, 0);"><strong>3、渗透探伤PT</strong></span></p><p><span style="color: rgb(0, 0, 0);">渗透检测原理是基于液体的毛细现象，和固体染料在一定条件下的发光现象为基础，进而进行对检测工件表面缺陷分析判断。在毛细作用下，经过一定时间，渗透剂可以渗入表面开口缺陷中;去除工件表面多余的渗透剂，经过干燥后，再在工件表面施涂吸附介质——显像剂，测出缺陷的形貌及分布状态。</span></p><p><span style="color: rgb(0, 0, 0);"><strong>4、射线探伤RT</strong></span></p><p><span style="color: rgb(0, 0, 0);">工业中常称为X-ray五大常用无损检测受手段之一，X射线是一种频率极高，波长极短、能量很大的电磁波，它能够穿透可见光不能穿透的物体，而且在穿透物体的同时将和物质发生复杂的物理和化学作用。</span></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);"><strong>无损探伤检测范围</strong></span></h2><p><span style="color: rgb(0, 0, 0);">1、焊缝表面缺陷检查：检查焊缝表面裂纹、未焊透及焊漏等焊接质量。</span></p><p><span style="color: rgb(0, 0, 0);">2、内腔检查：检查表面裂纹、起皮、拉线、划痕、凹坑、凸起、斑点、腐蚀等缺陷。</span></p><p><span style="color: rgb(0, 0, 0);">3、状态检查：当某些产品(如蜗轮泵、发动机等)工作后，按技术要求规定的项目进行内窥检测。</span></p><p><span style="color: rgb(0, 0, 0);">4、装配检查：当有要求和需要时，使用亚泰光电工业视频内窥镜对装配质量进行检查；装配或某一工序完成后，检查各零部组件装配位置是否符合图样或技术条件的要求；是否存在装配缺陷。</span></p><p><span style="color: rgb(0, 0, 0);">5、多余物检查：检查产品内腔残余内屑，外来物等多余物。</span></p>                    </div>
                </div>`
        };
    }

    return (

        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>
                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>
            {/*<img src={yemei}/>*/}

            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(435)}>
												<span>
													<i></i>力学试验介绍</span>
                                    </li>
                                    <li onClick={event => scroll(809)}>
												<span>
													<i></i>无损探伤检测方法</span>
                                    </li>
                                    <li onClick={event => scroll(1265)}>
												<span>
													<i></i>无损探伤检测范围</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>
                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                </div>
            </div>
            {/*<img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>*/}

             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
    );
};
export default App;
